import { render } from "./TransitionHeight.vue?vue&type=template&id=504ef3e9&scoped=true&ts=true"
import script from "./TransitionHeight.vue?vue&type=script&lang=ts"
export * from "./TransitionHeight.vue?vue&type=script&lang=ts"

import "./TransitionHeight.vue?vue&type=style&index=0&id=504ef3e9&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504ef3e9"]])

export default __exports__